import React from 'react';

import QuickMap from '@components/quick-map';

const Modals: React.FC = () => {
  return <QuickMap />;
};

export default Modals;
